import React from 'react';
import { cn } from '../../lib/utils';
import logo from '../../assets/images/logo.png';

/**
 * Header Component
 * 
 * Persistent header with crisp logo and minimal navigation.
 * Fixed position, glass-morphism backdrop, high contrast.
 * 
 * @returns {JSX.Element}
 */
export const Header = () => {
  return (
    <header
      className={cn(
        'fixed top-0 left-0 right-0',
        'z-50',
        'backdrop-blur-xl bg-navy-900/95',
        'border-b border-white/10',
        'shadow-[0_4px_24px_rgba(0,0,0,0.4)]'
      )}
      data-testid="app-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo - Blends seamlessly with navy background */}
          <div className="flex items-center">
            <img
              src={logo}
              alt="Bizhub"
              className="h-8 sm:h-10 w-auto"
              style={{
                imageRendering: 'crisp-edges',
                WebkitFontSmoothing: 'antialiased',
              }}
              data-testid="header-logo"
            />
          </div>

          {/* Navigation and CTA - Properly aligned */}
          <nav className="flex items-center gap-3 sm:gap-6">
            <a
              href="#orientation"
              className="text-sm text-white/80 hover:text-white transition-colors font-sans hidden md:inline-block"
            >
              Home
            </a>
            <a
              href="#leak"
              className="text-sm text-white/80 hover:text-white transition-colors font-sans hidden md:inline-block"
            >
              Discover
            </a>
            <button
              className="px-4 sm:px-6 py-2 sm:py-2.5 bg-teal-400 hover:bg-teal-500 text-slate-900 rounded-lg text-sm font-semibold transition-all duration-300 hover:shadow-[0_0_20px_rgba(17,197,217,0.4)] transform hover:scale-105"
              data-testid="header-cta"
            >
              Get Started
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};